import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DsButtonEmphasis, DsButtonV2Component } from '@customdesignsystem';
import {
  ERROR_STATE_CONTACT,
  ERROR_STATE_TEXTS,
} from '../../constants/error-state.constant';

@Component({
  selector: 'app-error-state',
  templateUrl: './error-state.component.html',
  styleUrl: './error-state.component.scss',
  imports: [CommonModule, RouterModule, DsButtonV2Component],
})
export class ErrorStateComponent {
  @Input() title = '';
  @Input() description = '';
  @Input() canRetry = false;
  @Input() retrying = false;

  @Output() retry = new EventEmitter<void>();
  @Output() goHome = new EventEmitter<void>();

  readonly texts = ERROR_STATE_TEXTS;
  readonly contact = ERROR_STATE_CONTACT;

  get homeEmphasis(): DsButtonEmphasis {
    return this.canRetry ? 'secondary-outlined' : 'primary';
  }
}
